"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const userService = {
  getUsers: function (options) {
    return api.get("/Users", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  getUser: function (id) {
    return api.get(`/Users/${id}`, WithToken.headersToken({}, configuration.cookieName));
  },
  blockStates: function (id, isBlocked) {
    return api.put(`/Users/${id}/BlockStates`, {}, WithToken.headersToken({ params: { isBlocked } }, configuration.cookieName));
  },
  createUser: function (options) {
    return api.post(`/Users`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createUserLocalVersion: function (options) {
    return api.post(`/Users/LocalVersion`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  createUserPermission: function (id, options) {
    return api.post(`/Users/${id}/permissions`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteUserPermission: function (id, options) {
    return api.delete(`/Users/${id}/permissions`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createUserOwnershipArea: function (id, options) {
    return api.post(`/Users/${id}/OwnershipAreas`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  deleteUserOwnershipArea: function (id, options) {
    return api.delete(`/Users/${id}/OwnershipAreas`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createUserUnit: function (options) {
    return api.post(`/UserUnits`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteUserUnit: function (options) {
    return api.delete(`/UserUnits`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  updatePasseord: function (id, options) {
    return api.put(`/Users/${id}/Password`, {}, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default userService;
